module.exports = __webpack_public_path__ + "img/jumbotron-home-bg.cb071ccf.jpg";